import { InitialState, ModalTypes } from '@Hooks/modalManager/modal.types.ts';
import { Icons } from '@Components/icon/Icon.tsx';

export const initialState: InitialState = {
  isActive: false,
  type: ModalTypes.NONE,
  icon: Icons.Oops,
  title: '',
  content: '',
  buttonText: '',
  button2Text: '',
  customComponent: undefined,
  onSubmit: () => {},
  onCancel: () => {},
};
